import React from 'react';
import { experience, education, technicalSkills, certifications } from '../../data/homeData';
import './ResumeSection.css';

const ResumeSection = () => {
  return (
    <section id="resume" className="section-card resume-section">
      <div className="resume-header">
        <h2 className="resume-title">
          <i className="fa-solid fa-briefcase fa-lg orange-icon" /> Professional Experience
        </h2>
      </div>

      <div className="resume-content">
        {/* Experience */}
        <div className="experience-section">
          {experience.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className="experience-header">
                <div className="experience-title">
                  <h3>{exp.role}</h3>
                  <div className="company-name">{exp.company}</div>
                </div>
                <div className="experience-period">{exp.period}</div>
              </div>
              <ul className="experience-highlights">
                {exp.highlights.map((highlight, highlightIndex) => (
                  <li key={highlightIndex}>{highlight}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Skills & Education Grid */}
        <div className="resume-grid">
          {/* Skills */}
          <div className="skills-section">
            <h3 className="section-heading">
              <i className="fa-solid fa-code orange-icon" /> Technical Skills
            </h3>
            <div className="skills-categories">
              <div className="skill-category">
                <h4>Development</h4>
                <div className="skill-tags">
                  {technicalSkills.development.map((skill, index) => (
                    <span key={index} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
              <div className="skill-category">
                <h4>Tools & Platforms</h4>
                <div className="skill-tags">
                  {[...technicalSkills.tools, ...technicalSkills.platforms].map((skill, index) => (
                    <span key={index} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Education & Certifications */}
          <div className="credentials-section">
            <div className="education-section">
              <h3 className="section-heading">
                <i className="fa-solid fa-graduation-cap orange-icon" /> Education
              </h3>
              <div className="education-item">
                <div className="degree">{education.degree}</div>
                <div className="school">{education.school}</div>
                <div className="year">{education.year}</div>
              </div>
            </div>

            <div className="certifications-section">
              <h3 className="section-heading">
                <i className="fa-solid fa-certificate orange-icon" /> Certifications
              </h3>
              <ul className="certifications-list">
                {certifications.map((cert, index) => (
                  <li key={index}>{cert}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResumeSection;